import React, { useEffect, useState } from 'react'

import { useDispatch } from 'react-redux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import {
  onSaveIndividualData,
  onCancelChanges,
  toggleNewLanguageOverlay,
  toggleLabelOverlay,
  setLanguage,
  onChangeData,
  onSaveData,
} from 'store/ConfigurationSettings/LanguageConfig/actions'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import Select from 'views/pages/Group/Select'
import AddNewLanguage from './AddNewLanguage'
import AddNewLabel from './AddNewLabel'

import './styles/styles.css'
import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import { getLanguages } from 'store/ConfigurationSettings/LanguageConfig/actions'

const LanguageConfig = (props) => {
  const dispatch = useDispatch()
  const { languageData } = props
  const language = props.language.data || {}
  const [activeItem, setActiveItem] = useState('Hints')
  const [defaultModal, setDefaultModal] = useState(false)

  const handleClick = (item, e) => {
    e.preventDefault()
    setActiveItem(item)
  }

  const onSaveDataMessage = () => {
    dispatch(onSaveData())
      .then(() => {
        toast.success(language?.alerts.changes_saved_succesfully, {
          position: toast.POSITION.TOP_CENTER,
          className: 'general-settings-toast',
          autoClose: 4000,
        })
      })
      .catch(() => {
        toast.error(language?.alerts.failed_to_save_changes, {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: 'general-settings-toast',
          autoClose: 4000,
        })
      })
  }

  const onSaveIndividualDataMessage = (category, key, value, index) => {
    dispatch(onSaveIndividualData(category, key, value, index))
      .then(() => {
        toast.success(language?.alerts.changes_saved_succesfully, {
          position: toast.POSITION.TOP_CENTER,
          className: 'general-settings-toast',
          autoClose: 4000,
        })
      })
      .catch(() => {
        let language = {}
        toast.error(language?.alerts.failed_to_save_changes, {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: 'general-settings-toast',
          autoClose: 4000,
        })
      })
  }
  const { languages, selectedLanguage, hasChanges } = languageData

  console.log(languages, 'languages$$$$$$$$')
  console.log(language, 'languages')
  console.log(languageData, 'languageDataAAAA')

  const setApprovalModal = (isOpen) => {
    setDefaultModal(isOpen)
  }

  useEffect(() => {
    dispatch(getLanguages())
  }, [dispatch])

  return (
    <div className='tab-content'>
      <div className='tab-content-header'>
        <div className='lang-selector'>
          <Select
            options={languages}
            selectedOptions={selectedLanguage}
            onChange={(e) => dispatch(setLanguage(e))}
            valueKey={'id'}
            multi={false}
            language={language}
            placeholder={'Select Language'}
          />
        </div>
        <button
          className='btn btn-info'
          onClick={() => {
            dispatch(toggleNewLanguageOverlay())
            setApprovalModal(true)
          }}
          style={{ height: '35px', padding: '7px 19px' }}
        >
          {language?.settings.add_language}
        </button>
        {props.user.id === '2' ? (
          <button
            className='btn btn-info add-label-button'
            onClick={() => dispatch(toggleLabelOverlay())}
            style={{ height: '35px', padding: '7px 19px' }}
          >
            {language?.settings.add_label}
          </button>
        ) : null}
      </div>
      <div className='row p-3 ml-0'>
        <div className='language-category__part'>
          <ul className='language-category-nav'>
            {languageData?.defaultLanguage.data
              ? Object.entries(languageData?.defaultLanguage.data).map(
                  (items, index) => {
                    return items[1][0] ? (
                      <li
                        key={index}
                        className={
                          activeItem === items[1][0].categoryName
                            ? 'active'
                            : ''
                        }
                      >
                        <a
                          onClick={(e) =>
                            handleClick(items[1][0].categoryName, e)
                          }
                          href='#'
                        >
                          {items[1][0].categoryName}
                        </a>
                      </li>
                    ) : null
                  }
                )
              : null}
          </ul>
        </div>
        <div className='language-translation__part scrollbar'>
          <div className=''>
            {Object.entries(languageData?.data)
              .filter(
                (category) =>
                  languageData.defaultLanguage.data[category[0]][0]
                    .categoryName === activeItem
              )
              .map((category, index) => {
                return (
                  <div className='col-12 lang-category-content' key={index}>
                    {
                      <h3
                        className='mt-1 pl-0'
                        id={
                          languageData.defaultLanguage.data[category[0]][0]
                            ? languageData.defaultLanguage.data[category[0]][0]
                                .categoryName
                            : null
                        }
                      >
                        {languageData.defaultLanguage.data[category[0]][0]
                          ? languageData.defaultLanguage.data[category[0]][0]
                              .categoryName
                          : null}
                      </h3>
                    }
                    {category[1].map((item, index) => {
                      return (
                        <div className='row single-string-row' key={index}>
                          <div className='col-6'>
                            <label
                              className='language-label'
                              htmlFor={
                                languageData.defaultLanguage.data[category[0]][
                                  index
                                ] &&
                                languageData.defaultLanguage.data[category[0]][
                                  index
                                ].value
                              }
                            >
                              {languageData.defaultLanguage.data[category[0]][
                                index
                              ] &&
                                languageData.defaultLanguage.data[category[0]][
                                  index
                                ].value}
                              :{' '}
                            </label>
                          </div>
                          <div className='col-6 change-label-part'>
                            <div className='language-input-row'>
                              <input
                                type='text'
                                name={item.key}
                                autoFocus={props.autoFocus}
                                value={item && item.value}
                                onChange={(evt) =>
                                  dispatch(
                                    onChangeData(
                                      category[0],
                                      item.key,
                                      evt.target.value,
                                      index
                                    )
                                  )
                                }
                              />
                            </div>
                            <button
                              className='btn btn-transparent btn-update-string'
                              disabled={item.isDisabled}
                              onClick={() =>
                                dispatch(
                                  onSaveIndividualDataMessage(
                                    category[0],
                                    item.key,
                                    item && item.value,
                                    index
                                  )
                                )
                              }
                            >
                              <FontAwesomeIcon icon={faCheckCircle} />
                            </button>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                )
              })}
          </div>
        </div>
      </div>

      <div className='col mt-3 mb-3'>
        <SubmitModalButton
          disabled={hasChanges === true ? false : true}
          text={language?.settings.save_all}
          customFn={onSaveDataMessage}
        />
        <CancelModalButton
          disabled={hasChanges === true ? false : true}
          text={language?.settings.cancel_changes}
          customFn={() => dispatch(onCancelChanges())}
        />
      </div>
      {languageData.overlayIsShowing ? (
        <AddNewLanguage
          {...props}
          languageData={props.languageData}
          defaultModal={defaultModal}
        />
      ) : null}
      {languageData.labelOverlayIsShowing ? (
        <AddNewLabel
          {...props}
          languageData={props.languageData}
          defaultModal={defaultModal}
        />
      ) : null}
      <ToastContainer />
    </div>
  )
}
export default LanguageConfig
